import axios from '../utils/axios';

export default function fetchIntegrations(adminId, integration, params) {
    return axios.get(`/admin/${adminId}/ats-integrations/${integration}/recruiters`, { params })
}
